import { Component,Input, OnInit } from '@angular/core';
import { SicotService } from '../../sicot.service';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-sessione-uvm',
    imports: [CommonModule, MatCardModule],
    templateUrl: './sessione-uvm.component.html',
    styleUrl: './sessione-uvm.component.css'
})
export class SessioneUvmComponent implements OnInit {

  API_ENDPOINT_COT_SERVICE = environment.API_ENDPOINT_COT_SERVICE;

  sessione:Sessione | undefined;

  ngOnInit(): void {
    this.getRichiesta(this.idRichiesta)
    .subscribe((richiesta: Sessione) => {

      this.sessione = richiesta;
    })
  }

  @Input() idRichiesta: any;

  @Input() stato: any;

  constructor(private siCotService:SicotService,private http:HttpClient){

  }

  getRichiesta(id: number): Observable<any> {
    return this.http
      .get<any>(this.API_ENDPOINT_COT_SERVICE + `/sessioni-uvm/${id}`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }
}


export interface Qualifica {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Operatore {
  id: number;
  codiceFiscale: string;
  nome: string;
  cognome: string;
  dataDiNascita: string;  // Date format as string
  codice: string;
  qualifica: Qualifica;
}

export interface Struttura {
  id: number;
  codice: string;
  descrizione: string;
  strutturaPadre: string | null;  // Can be null or a string
}

export interface Sessione {
  id: number;
  data: string;  // Date format as string
  oraInizio: string;  // Time format as string
  oraFine: string;  // Time format as string
  durata: number;
  struttura: Struttura;
  operatori: Operatore[];
  cotRichiestaOid: number;
  confermata:boolean;
  codice: string | null;  // Can be null
}